
import React from "react";
import {
  HiOutlineSun,
  HiOutlineMoon,
} from "react-icons/hi2";

import { useStateContext } from "../../context/ContextProvider";

function ToggleDark() {
  const { currentMode, setMode } = useStateContext();

  const isDark = currentMode === "Dark";

  const toggleTheme = () => {
    setMode(isDark ? "Light" : "Dark");
  };

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={
        isDark
          ? "تفعيل الوضع النهاري"
          : "تفعيل الوضع الليلي"
      }
      aria-pressed={isDark}
      title={isDark ? "Light Mode" : "Dark Mode"}
      className="
        group inline-flex h-10 w-10
        shrink-0 items-center
        justify-center rounded-xl
        border border-skin-border
        bg-skin-soft/70
        text-skin-heading
        transition-all duration-200

        hover:border-skin-accent/35
        hover:bg-skin-raised

        focus-visible:outline-none
        focus-visible:ring-2
        focus-visible:ring-skin-accent

        dark:border-white/10
        dark:bg-white/[0.07]
        dark:text-white
        dark:hover:bg-white/[0.12]
      "
    >
      {isDark ? (
        <HiOutlineSun
          size={21}
          aria-hidden="true"
          className="
            transition-transform duration-300
            group-hover:rotate-45
            group-hover:text-skin-accent
          "
        />
      ) : (
        <HiOutlineMoon
          size={20}
          aria-hidden="true"
          className="
            transition-transform duration-300
            group-hover:-rotate-12
            group-hover:text-skin-accent
          "
        />
      )}
    </button>
  );
}

export default ToggleDark;
